import { cloneDeep } from 'lodash-es'
import { toRaw, unref } from 'vue'

const unwrapCloneInput = <T>(value: T): T => toRaw(unref(value)) as T

export const appStructuredClone = <T>(value: T): T => {
  const rawValue = unwrapCloneInput(value)

  if (typeof structuredClone === 'function') {
    try {
      return structuredClone(rawValue)
    } catch {
      // structuredClone fails on some proxied/non-cloneable values.
    }
  }

  return cloneDeep(rawValue)
}
